import React from "react";
import "../App.css";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { postMaterialDeclaration, postMaterialDeclarationRemarks } from "../Actions/MaterialDeclarationAPI";
import API from "../helpers/api";
import axios from "axios";
import { toast } from "react-toastify";
import * as moment from 'moment';
import { getSixMonthReview, postSixMonthReview } from "../Actions/ShipViewAPI";
import swal from "sweetalert";
import AddIcon from "../UIComponents/AddIcon";

var today = new Date();
var currentDate = moment(today).format("DD MMM YYYY");
var currentDateForAPI = moment(today).format("YYYY-MM-DD");

class ShipViewReview extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            shipId: "",
            revisionNo: "",
            dateOfRevision: currentDateForAPI,
            reviewedBy: "",
            areAllStaffConcernedFamiliarWithTheIhmpartI: "",
            isIhmpartIupdatedProperly: "",
            isListOfDeliveryRecorded: "",
            mdAndSdoCrecorded: "",
            isIhmcertificateValidAndNecessaryInspectionsAreCarried: "",
            areThereAnyAbnormality: "",
            others: "",
            isThereAnyChangesToIhmpartI: "",
            reviewObservationAndCorrectiveActions: "",
            createdBy: ""
        };
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    componentDidMount() {
        const { dispatch, match } = this.props;
        dispatch({ type: 'SubBannerTitle', data: "Material Declaration" });
        if (match.params.shipId) {
            dispatch(getSixMonthReview(match.params.shipId));
        }

    }


    SubmitReview = () => {
        const { dispatch, match } = this.props;
        this.state.shipId = match.params.id;
        if(this.state.isThereAnyChangesToIhmpartI === ''){
            swal('Error!', ' "Is there any changes to IHMpart1" cannot be empty', 'warning')
        }
        else{
        dispatch(postSixMonthReview(this.state));
        this.props.history.goBack();
        }
    }

    onHandleInputChange(e) {
        const { dispatch } = this.props;
        let nodeName = e.target.name;
        if (nodeName === "MDoc") {
            this.state.declarationDetails.mdAttachmentName = e.target.files[0].name;
            this.state.mdocfile = e.target.files[0];
            this.setState({ declarationDetails: this.state.declarationDetails });
            let postItem = e.target.files[0];
            const data = new FormData()
            data.append('file', postItem)
            let url = `${API.AttachmentAPI}`;
            axios.post(url, data)
                .then((response) => {
                    dispatch({
                        type: "AttachmentUploadMDocSuccess",
                        data: response.data,
                    })
                })
                .catch((error) => {
                    dispatch({
                        type: "AttachmentUploadMDocFailure",
                        error: "ERROR"
                    })
                    toast.success('Document is already uploaded.Please upload different document', {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                })
        } else if (nodeName === "SDoc") {
            this.state.declarationDetails.sdocAttachmentName = e.target.files[0].name;
            this.state.sdocfile = e.target.files[0];
            this.setState({ declarationDetails: this.state.declarationDetails });
            let postItem = e.target.files[0];
            const data = new FormData()
            data.append('file', postItem)
            let url = `${API.AttachmentAPI}`;
            axios.post(url, data)
                .then((response) => {
                    dispatch({
                        type: "AttachmentUploadSDocSuccess",
                        data: response.data,
                    })
                })
                .catch((error) => {
                    dispatch({
                        type: "AttachmentUploadSDocFailure",
                        error: "ERROR"
                    })
                    toast.success('Document is already uploaded.Please upload different document', {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                    });
                })
        }
    }

    handleInputChange = (e, field) => {
        let nodeName = e.target.name;
        if (field == "isThereAnyChangesToIhmpartI") {
            let value = e.target.value;
            if (value === "true" || value === "false") {
                value = JSON.parse(value);
                this.state[field] = value;
            }
        }
        else {
            this.state[field] = e.target.textContent;
        }
        this.setState({});
    }

    hideSidePanel = () => {
        this.props.history.goBack();
    }

    render() {
        const { shipDetail } = this.props;
        return (
            <div className="full-height my-3">
                <div className="card MM-card-header m-auto">
                    <div className="card-body">
                        <h5 className="card-title ml-2 mt-2">IHM Review</h5>
                    </div>
                </div>
                <div className="panel-box p-3">
                    <div className="row mt-3">
                        {/* Product information Table */}
                        <div className="col-lg-12">
                            <table className="material-decalaration-table table">
                                <tr>
                                    <th>Name of the ship: </th>
                                    <td contentEditable="false">{shipDetail.shipName}</td>
                                    <td rowSpan="2" contentEditable={false} onBlur={(e) => this.handleInputChange(e, "reviewedBy")}>{this.state.reviewedBy}</td>
                                </tr>
                                <tr>
                                    <th>Date of Review: </th>
                                    <td contentEditable="false" >{currentDate}</td>
                                </tr>
                                <tr>
                                    <th colSpan="2">Description</th>
                                    <th>Status</th>
                                </tr>
                                <tr>
                                    <th colSpan="2">Are all staff concerned familiar with the IHM Part-I and the relevant manuals are being kept properly? </th>
                                    <td contentEditable={true} onBlur={(e) => this.handleInputChange(e, "areAllStaffConcernedFamiliarWithTheIhmpartI")}>{this.state.areAllStaffConcernedFamiliarWithTheIhmpartI}</td>
                                </tr>
                                <tr>
                                    <th colSpan="2">Is IHM Part I – Updated properly? </th>
                                    <td contentEditable={true} onBlur={(e) => this.handleInputChange(e, "isIhmpartIupdatedProperly")}>{this.state.isIhmpartIupdatedProperly}</td>
                                </tr>
                                <tr>
                                    <th colSpan="2">MD and SDoC’s recorded and details maintained onboard? </th>
                                    <td contentEditable={true} onBlur={(e) => this.handleInputChange(e, "mdAndSdoCrecorded")}>{this.state.mdAndSdoCrecorded}</td>
                                </tr>
                                <tr>
                                    <th colSpan="2">Is IHM Certificate Valid and necessary inspections are carried out within the due date ? </th>
                                    <td contentEditable={true} onBlur={(e) => this.handleInputChange(e, "isIhmcertificateValidAndNecessaryInspectionsAreCarried")}>{this.state.isIhmcertificateValidAndNecessaryInspectionsAreCarried}</td>
                                </tr>
                                <tr>
                                    <th colSpan="2">Is List of delivery and dismantlement relating to works recorded and updated ? </th>
                                    <td contentEditable={true} onBlur={(e) => this.handleInputChange(e, "isListOfDeliveryRecorded")}>{this.state.isListOfDeliveryRecorded}</td>
                                </tr>
                                <tr>
                                    <th colSpan="2">Are there any abnormality as results of verification of each record observed during the review? </th>
                                    <td contentEditable={true} onBlur={(e) => this.handleInputChange(e, "areThereAnyAbnormality")}>{this.state.areThereAnyAbnormality}</td>
                                </tr>
                                <tr>
                                    <th colSpan="2">Others </th>
                                    <td contentEditable={true} onBlur={(e) => this.handleInputChange(e, "others")}>{this.state.others}</td>
                                </tr>
                                <tr>
                                    <th colSpan="2">Is there any changes to IHM Part I  </th>
                                    <td className="p-0">
                                        <select className="table-editable-dropdown" value={this.state.isThereAnyChangesToIhmpartI} onChange={(e) => this.handleInputChange(e, "isThereAnyChangesToIhmpartI")}>
                                            <option value=""></option>
                                            <option value="true">YES</option>
                                            <option value="false">NO</option>
                                        </select>
                                    </td>
                                </tr>
                                <tr>
                                    <th colSpan="4">Review observation and corrective actions (if any): </th>
                                </tr>
                                <tr>
                                    <td colSpan="4" contentEditable={true} onBlur={(e) => this.handleInputChange(e, "reviewObservationAndCorrectiveActions")}>{this.state.reviewObservationAndCorrectiveActions}</td>
                                </tr>
                                <tr>
                                    <th colSpan="2">Designated Person (Name/Signature): </th>
                                    <td contentEditable={true} onBlur={(e) => this.handleInputChange(e, "productName")}>{ }</td>
                                </tr>
                                <tr>
                                    <th colSpan="2">Date:                                                                     </th>
                                    <td contentEditable={true} onBlur={(e) => this.handleInputChange(e, "productName")}></td>
                                </tr>
                                {/* <td contentEditable={true} onBlur={(e) => this.handleInputChange(e, "productNumber")}></td>
                                    <td style={{ textAlignLast: "center" }} contentEditable={true} onBlur={(e) => this.handleInputChange(e, "productQuantityAmount")}></td>
                                  
                                    <td contentEditable={true} onBlur={(e) => this.handleInputChange(e, "productInfo")}></td>
                                </tr> */}
                            </table>
                        </div>
                    </div>

                    <div className="row">
                        <div className={"col-lg-12 mt-4"}>
                            <div className=" search-btn-col" style={{ textAlign: "end" }}>
                                < button
                                    className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                                    type="submit" onClick={() => this.SubmitReview()}>
                                    Submit
                                </button>
                                <button
                                    className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                                    type="button" onClick={() => this.hideSidePanel()}>
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        );
    }
}

function mapStateToProps(state) {
    return {
        MDocAttachment: state.MMPLDashboardReducer.MDocAttachment,
        SDocAttachment: state.MMPLDashboardReducer.SDocAttachment,
        PODetail: state.POViewReducer.PODetail,
        POLineItem: state.POViewReducer.POLineItem,
        sixMonthReview: state.ShipViewReducer.SixMonthReview || {},
        shipDetail: state.ShipViewReducer.ShipDetail || {},
    };
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}
export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(ShipViewReview)
);
